<div class="graph-test-page social-test-page">
  <header class="graph-test-header">
    <h1>Social sign-in test</h1>
    <p class="hint">
      <strong>Google:</strong> Google Identity Services popup → authorization code → Accounts
      <code>POST test/google-sign-in</code> → Google token endpoint (not Entra / MSAL).
      Requires <code>GOOGLE_OAUTH_CLIENT_ID</code> + secret on Accounts API and
      <code>googleOAuthClientId</code> in Angular env (same Web client; authorized JavaScript
      origin <code>https://localhost:4200</code>).
    </p>
  </header>

  <div class="actions">
    <a routerLink="/login" class="link">Back to sign-in</a>
  </div>

  <section class="panel">
    <h2>Continue with</h2>
    <button
      type="button"
      class="social-btn"
      [disabled]="googleLoading || !googleConfigured"
      (click)="continueWithGoogle()"
    >
      <svg class="social-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        />
        <path
          fill="#34A853"
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        />
        <path
          fill="#FBBC05"
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        />
        <path
          fill="#EA4335"
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        />
      </svg>
      {{ googleLoading ? 'Signing in…' : 'Continue with Google' }}
    </button>
    <p class="error" *ngIf="googleError">{{ googleError }}</p>
    <div *ngIf="googleResultJson">
      <h3 class="subhead">Google sign-in result</h3>
      <pre>{{ googleResultJson }}</pre>
    </div>
    <button type="button" class="social-btn">
      <svg class="social-icon apple" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.365 1.43c0 1.14-.42 2.2-1.22 3.03-.9.94-2.1 1.53-3.25 1.44-.14-1.1.4-2.25 1.2-3.12.9-.95 2.25-1.62 3.27-1.35zm4.54 16.34c-.4.92-.87 1.77-1.42 2.55-.75 1.06-1.36 1.8-2.25 1.82-.8.02-1.06-.48-2.2-.48s-1.45.46-2.25.5c-.88.04-1.55-.8-2.3-1.86-1.54-2.16-2.72-6.1-1.14-8.77.78-1.33 2.05-2.17 3.47-2.19.86-.02 1.67.58 2.2.58.52 0 1.5-.72 2.53-.61.43.02 1.64.17 2.42 1.3-.06.04-1.44.84-1.42 2.52.02 2 1.74 2.66 1.76 2.67-.02.06-.27.94-.6 1.87z"
        />
      </svg>
      Continue with Apple
    </button>
  </section>
</div>
